import React from "react";
import { Text, View } from "react-native";
import { useLocalSearchParams, useRouter } from "expo-router";
import { EmailOtpType } from "@supabase/supabase-js";

import { supabaseClient } from "~/lib/supabase";

export default function Token() {
  const { token_hash: token_hash, next, type } = useLocalSearchParams();

  const { replace } = useRouter();
  const [error, setError] = React.useState<string>();

  React.useEffect(() => {
    if (typeof token_hash === "string" && typeof type === "string") {
      supabaseClient.auth
        .verifyOtp({
          type: type as EmailOtpType,
          token_hash,
        })
        .then((response) => {
          if (response.error) {
            console.error(response.error);
            setError(response.error.message);
          } else {
            if (typeof next === "string") setTimeout(() => replace(next), 0);
            else setTimeout(() => replace("/"), 0);
          }
        })
        .catch((e) => {
          console.error({ e });
        });
    }
  }, [token_hash]);

  if (!token_hash || !type)
    return (
      <View>
        <Text className="text-text-primary">No token found</Text>
      </View>
    );

  if (error) {
    return (
      <View>
        <Text className="text-text-primary">{error}</Text>
      </View>
    );
  }

  return (
    <View>
      <Text className="text-text-primary">Validating token</Text>
    </View>
  );
}
